






	// @ts-ignore
    import _ from './SBg.ts'; export default _;
